import { Switch } from '@mantine/core';
import { useGrowthbookContext } from '@/app/contexts/GrowthbookContext';
import { useShowNewPresets } from '@/app/contexts/ShowNewPresetsContext';

export const PreviewNewSettingsToggle = () => {
  const { showNewPresets, setShowNewPresets } = useShowNewPresets();
  const growthbook = useGrowthbookContext();

  if (!growthbook || growthbook?.isOn('new-settings-full-release')) {
    return null;
  }

  return (
    <Switch
      checked={showNewPresets}
      label='Preview New Settings'
      onChange={(e) => setShowNewPresets(e.currentTarget.checked)}
    />
  );
};
